import { Channel, channel, buffers, Saga } from "redux-saga";
import { call, fork, take } from "redux-saga/effects";

import { SagaAction } from "utils/asyncActions";

const bufferedChannels: { [key: string]: Channel<SagaAction> } = {};

export function* handleBufferedChannel(
  bufferedChannel: Channel<SagaAction>,
  worker: Saga
): Generator {
  while (true) {
    const action = yield take(bufferedChannel);
    yield call(worker, action);
  }
}

export function* takeBuffered(type: string, worker: Saga): Generator {
  while (true) {
    // We want this generator to be the 'taker' immediately,
    // ... so subsequent .put() effects don't get re-consumed
    const action = yield take(type);

    // Extract the requestKey from the action
    const { requestKey } = action as SagaAction;

    // Use an existing channel for the key, or create a new one
    let bufferedChannel;
    if (bufferedChannels.hasOwnProperty(requestKey)) {
      bufferedChannel = bufferedChannels[requestKey];
    } else {
      bufferedChannel = yield call(channel, buffers.sliding(1));
      bufferedChannels[requestKey] = bufferedChannel as Channel<SagaAction>;

      // Fork a single worker
      yield fork(handleBufferedChannel as Saga, bufferedChannel, worker);
    }

    yield (bufferedChannel as Channel<SagaAction>).put(action as SagaAction);
  }
}

export const getBufferedChannels = () => bufferedChannels;
